import React, { useRef, useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight, FaTimes, FaExpand } from "react-icons/fa";
import { motion, AnimatePresence, color } from "framer-motion";
import "./gallerie.css";

const images = [
  { src: require('./assets/chambre.jpg'), alt: "Chambre d'hôte" },
  { src: require('./assets/plageP.jpg'), alt: "Plage Privée" },
  { src: require('./assets/vueC.jpg'), alt: "Plage Privée" },
  { src: require('./assets/chambre1.jpg'), alt: "Chambre confortable" },
  { src: require('./assets/chambre4.jpg'), alt: "Chambre confortable" },
  { src: require('./assets/chambre5.jpg'), alt: "Chambre confortable" },
  { src: require('./assets/c.jpg'), alt: "Piscine intérieure" },
  { src: require('./assets/Piscine5.jpg'), alt: "Piscine intérieure" },
  { src: require('./assets/chambre2.jpg'), alt: "Suite spacieuse" },
  { src: require('./assets/sport.jpg'), alt: "Chambre d'hôte" },
  { src: require('./assets/chambre3.jpg'), alt: "Piscine extérieure" },
  { src: require('./assets/chambreD15.jpg'), alt: "Chambre confortable" },
  { src: require('./assets/romantique.jpg'), alt: "Chambre confortable" },
  { src: require('./assets/bejaia.jpg'), alt: "Piscine intérieure" },
  { src: require('./assets/suiteRouge.jpg'), alt: "Chambre d'hôte" },
  { src: require('./assets/images.jpg'), alt: "Piscine intérieure" },
  { src: require('./assets/chambre7.jpg'), alt: "Chambre confortable" },
  { src: require('./assets/sport1.jpg'), alt: "Chambre d'hôte" },
  { src: require('./assets/chambreSingle.jpg'), alt: "Chambre confortable" },
  { src: require('./assets/vue1.jpg'), alt: "Chambre confortable" },
  { src: require('./assets/vue4.jpg'), alt: "Suite spacieuse" },
  { src: require('./assets/triple.jpg'), alt: "Suite spacieuse" },
  { src: require('./assets/suiteee.jpg'), alt: "Chambre d'hôte" },
  { src: require('./assets/leverDeSoliel.jpg'), alt: "Piscine intérieure" },
  { src: require('./assets/hotel-syphax.jpg'), alt: "Chambre confortable" },
  { src: require('./assets/chambre8.jpg'), alt: "Suite spacieuse" },
  { src: require('./assets/vueChambre.jpg'), alt: "Suite spacieuse" },
  { src: require('./assets/hotel.jpg'), alt: "Piscine intérieure" },
  { src: require('./assets/parking.jpg'), alt: "Chambre d'hôte" },
  { src: require('./assets/vueRomantique.jpg'), alt: "Suite spacieuse" },
  { src: require('./assets/picineE.jpg'), alt: "Chambre confortable" },
  { src: require('./assets/vue.jpg'), alt: "Suite spacieuse" },
  { src: require('./assets/hotel1.jpg'), alt: "Piscine intérieure" },
  { src: require('./assets/parking1.jpg'), alt: "Chambre d'hôte" },
  { src: require('./assets/sport.jpg'), alt: "Piscine extérieure" },
  { src: require('./assets/piscine.jpg'), alt: "Piscine intérieure" },
  { src: require('./assets/piscine1.jpg'), alt: "Suite spacieuse" },
  { src: require('./assets/hammam.jpg'), alt: "Piscine extérieure" },
  { src: require('./assets/piscineEX.jpg'), alt: "Piscine intérieure" },
  { src: require('./assets/accieul.jpg'), alt: "Piscine intérieure" },
];

export default function Gallery() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const containerRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const scroll = (direction) => {
    if (!containerRef.current) return;
    
    const container = containerRef.current;
    const scrollAmount = container.clientWidth * 0.8;
    const newScrollLeft = direction === "left" 
      ? container.scrollLeft - scrollAmount 
      : container.scrollLeft + scrollAmount;
    
    container.scrollTo({
      left: newScrollLeft,
      behavior: "smooth"
    });
  };

  const handleImageClick = (index) => {
    setActiveIndex(index);
  };

  const handleClose = () => {
    setActiveIndex(null);
    setIsFullscreen(false);
  };

  const handleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  const handleSwipeStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleSwipeMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleSwipeEnd = () => {
    if (touchStartX.current - touchEndX.current > 50) {
      // Swipe left
      setActiveIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
    }
    
    if (touchStartX.current - touchEndX.current < -50) {
      // Swipe right
      setActiveIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
    }
  };

  const handleKeyDown = (e) => {
    if (activeIndex === null) return;
    
    if (e.key === "ArrowRight") {
      setActiveIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
    } else if (e.key === "ArrowLeft") {
      setActiveIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
    } else if (e.key === "Escape") {
      handleClose();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [activeIndex]);

  return (
    <section className="gallery-section" id="gallery">
      <h2 className="gallery-title">Galerie</h2>
      
      <div className="gallery-wrapper">
        <button 
          className="scroll-button left" 
          onClick={() => scroll("left")}
          aria-label="Scroll left"
        >
          <FaChevronLeft />
        </button>

        <div 
          className="gallery-container" 
          ref={containerRef}
        >
          {images.map((image, index) => (
            <motion.div
              key={index}
              className="gallery-item"
              onClick={() => handleImageClick(index)}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="gallery-image"
                loading="lazy"
                decoding="async"
              />
              <div className="image-caption">{image.alt}</div>
            </motion.div>
          ))}
        </div>

        <button 
          className="scroll-button right" 
          onClick={() => scroll("right")}
          aria-label="Scroll right"
        >
          <FaChevronRight />
        </button>
      </div>

      <AnimatePresence>
        {activeIndex !== null && (
          <motion.div 
            className="lightbox-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleClose}
          >
            <motion.div 
              className="lightbox-content"
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="lightbox-controls">
                <button 
                  className="lightbox-button fullscreen-button"
                  onClick={handleFullscreen}
                  aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
                >
                  <FaExpand />
                </button>
                <button 
                  className="lightbox-button close-button"
                  onClick={handleClose}
                  aria-label="Close image"
                >
                  <FaTimes />
                </button>
              </div>
              
              <img
                src={images[activeIndex].src}
                alt={images[activeIndex].alt}
                className={`lightbox-image ${isFullscreen ? 'fullscreen' : ''}`}
              />
              
              <div className="lightbox-navigation">
                <button 
                  className="nav-button prev"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
                  }}
                  aria-label="Previous image"
                >
                  <FaChevronLeft  />
                </button>
                
                <div className="image-counter">
                  {activeIndex + 1} / {images.length}
                </div>
                
                <button 
                  className="nav-button next"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
                  }}
                  aria-label="Next image"
                >
                  <FaChevronRight  />
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}